import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDvx5P6IRdS26n4LvgJ5jYjIY3cJdbpsvs",
  authDomain: "clgmbh-ctoflash.firebaseapp.com",
  databaseURL: "https://clgmbh-ctoflash.firebaseio.com",
  projectId: "clgmbh-ctoflash",
  storageBucket: "clgmbh-ctoflash.appspot.com",
  messagingSenderId: "120320139140",
  appId: "1:120320139140:web:77ac262affd528ae",
}; 

const region = 'europe-west3';

const firebase = initializeApp(firebaseConfig);

const auth = getAuth(firebase);
const firestore = getFirestore(firebase);
const functions = getFunctions(firebase, region);
const storage = getStorage(firebase);

if (location.hostname === 'localhost') {
  connectAuthEmulator(auth, 'http://localhost:9099', {disableWarnings: true});
  connectFirestoreEmulator(firestore, 'localhost', 8088);
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectStorageEmulator(storage, "localhost", 9199);
}

export {firebase, auth, functions, storage, firestore} 